"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Qualifiers = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

var QualifierDiv = _styledComponents["default"].div.withConfig({
  displayName: "QualifierDiv",
  componentId: "sc-1gh0l3h-0"
})(["display:flex;flex-wrap:wrap;width:100%;justify-content:space-between;"]);

var IconDiv = _styledComponents["default"].div.withConfig({
  displayName: "IconDiv",
  componentId: "sc-1gh0l3h-1"
})(["display:flex;width:16px;height:16px;align-items:center;@media (", "){width:24px;height:24px;}"], _baseReactComponents.theme.forLargerThanPhone);

var QualifierRow = _styledComponents["default"].div.withConfig({
  displayName: "QualifierRow",
  componentId: "sc-1gh0l3h-2"
})(["display:flex;margin-bottom:8px;width:49%;align-items:center;"]);

var Qualifier = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "Qualifier",
  componentId: "sc-1gh0l3h-3"
})(["padding-left:6px;"]);

var Qualifiers = function Qualifiers(_ref) {
  var loanOffer = _ref.loanOffer;
  var qualifiers = (0, _lodash["default"])(loanOffer, 'qualifiers', []);
  var qualIconsDict = {
    pass: 'actions/check-circle',
    fail: 'actions/circle-delete'
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(QualifierDiv, {
    children: qualifiers.map(function (qualifier, index) {
      var qualIcon = (0, _lodash["default"])(qualIconsDict, qualifier.evaluation, 'actions/circle-faq');
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(QualifierRow, {
        qualifier: qualifier,
        "data-testid": "loancard:qualifierrow",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(IconDiv, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
            "data-testid": "icon-".concat(qualIcon),
            name: qualIcon,
            color: _baseReactComponents.theme.neutral400
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Qualifier, {
            size: "xxs",
            shouldScaleFont: true,
            light: true,
            "data-testid": "loancard:qualifier",
            className: "js-private",
            "data-heap-redact-text": "true",
            children: [qualifier.title, ": ", qualifier.value]
          })
        })]
      }, index);
    })
  });
};

exports.Qualifiers = Qualifiers;
var _default = Qualifiers;
exports["default"] = _default;
//# sourceMappingURL=qualifiers.js.map